module.exports = __webpack_public_path__ + "img/21.bee0cfac.jpg";